import * as yup from 'yup'

const schema = yup.object().shape({
  responsibleUsers: yup
    .array()
    .min(1, 'É necessário atribuir ao menos um responsável.')
    .required('É necessário atribuir ao menos um responsável.'),
  expiration: yup.bool(),
  expirationType: yup.number(),

  dueDate: yup
    .mixed()
    .typeError('Precisa ser uma data válida')
    .nullable()
    .when(['expiration', 'expirationType'], {
      is: (expiration, expirationType) =>
        expiration === true && expirationType === 0,
      then: yup.date().required().notInPast(),
    }),

  expirationTime: yup.number().when(['expiration', 'expirationType'], {
    is: (expiration, expirationType) =>
      expiration === true && expirationType === 1,
    then: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === '' ? undefined : value,
      )
      .required(),
  }),

  expirationUnit: yup.string().when(['expiration', 'expirationType'], {
    is: (expiration, expirationType) =>
      expiration === true && expirationType === 1,
    then: yup.string().required(),
  }),
})

export default schema
